import { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios'

export async function authenticatedRequestInterceptorBO(
  config: AxiosRequestConfig<any>
) {
  config.headers = {
    ...config.headers,
    Authorization: `boostEhgd61ko9038`
  }

  return config as InternalAxiosRequestConfig
}
